var StickerEditorModeManager = require('./sticker');

function PlaceholderEditorModeManager () { this.type = 'placeholder'; }
PlaceholderEditorModeManager.prototype = new StickerEditorModeManager();
module.exports = PlaceholderEditorModeManager;
